import React from 'react';
import { StyledLeftSide, StyledImageLogo, StyledImageBoy } from '../../../components/Styled/StyledLeftSide';
import boy from '../../../assets/boy.png';
import logo from './../../../assets/loginlogo.png';

export const LeftSide = (): JSX.Element => {
  return (
    <StyledLeftSide data-testid="left-side">
      <StyledImageLogo src={logo as string} alt="logo" />
      <StyledImageBoy src={boy as string} alt="boy" />
    </StyledLeftSide>
  );
};
